import styled from 'styled-components';

const ViewWrapper = styled.div``;

export { ViewWrapper };
